import {
  type Action,
  type Computed,
  FilterActionTypes,
  action,
  computed,
} from "easy-peasy";

import { DEFAULT_END_TIME, DEFAULT_START_TIME } from "./default";
import { type LogEffect, createLogEffect } from "../../utils/store";

const logEffect = (property: keyof FilterActionTypes<TimesModel>) =>
  createLogEffect<TimesModel>("TIMES", property, false);

export type Time = number | null;

export type TimesModel = {
  start: Time;
  startOnChange: LogEffect<TimesModel>;
  setStart: Action<TimesModel, Time>;
  end: Time;
  endOnChange: LogEffect<TimesModel>;
  setEnd: Action<TimesModel, Time>;
  isSet: Computed<TimesModel, boolean>;
  isSetOnChange: LogEffect<TimesModel>;
};

const timesModel: TimesModel = {
  start: DEFAULT_START_TIME,
  startOnChange: logEffect("start"),
  setStart: action((state, payload) => {
    state.start = payload;
  }),
  end: DEFAULT_END_TIME,
  endOnChange: logEffect("end"),
  setEnd: action((state, payload) => {
    state.end = payload;
  }),
  isSet: computed(
    (state) =>
      state.start !== DEFAULT_START_TIME || state.end !== DEFAULT_END_TIME,
  ),
  isSetOnChange: logEffect("isSet"),
};

export default timesModel;
